import styled from "styled-components";

export const LinkContainer = styled.div`
    margin-top: 50px;
`;
